import * as angular from "angular";
import {IController} from "angular";

export class RolesGroupsTableComponent implements IController {
  groups: any;
  onDelete: Function;
  onEdit: Function;
  onAddUsers: Function;
  onRemoveUsers: Function;

  private groupNameTagColor = '#7E92EA';

  constructor() {
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('rolesGroupsTable', {
    bindings: {
      groups: '<',
      onDelete: '&',
      onEdit: '&',
      onAddUsers: '&',
      onRemoveUsers: '&'
    },
    template: require('./roles-groups-table.html').default,
    controller: RolesGroupsTableComponent
  });

